export function groupBy(arr, criteria) {
  return arr.reduce(function (obj, item) {
    // Check if the criteria is a function to run on the item or a property of it
    var key = typeof criteria === 'function' ? criteria(item) : item[criteria]

    // If the key doesn't exist yet, create it
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      obj[key] = []
    }

    // Push the value to the object
    obj[key].push(item)

    // Return the object to the next item in the loop
    return obj
  }, {})
}

const lookupIcon = (code) => {
  switch (code.trim()) {
    case 'IG1':
      return 'plan-retirement'
    case 'IG5':
      return 'grow-assets'
    case 'IG4':
      return 'navigate-rates'
    case 'IG3':
      return 'ease-impact'
    case 'IG2':
      return 'maximize-returns'
    default:
      return ''
  }
}

const convertDate = (d) => {
  const date = new Date(d)
  if (d && date instanceof Date && !isNaN(date)) {
    const dateSplit = d.split('-')
    const day = dateSplit[2].split('T')[0]

    return `${dateSplit[1]}/${day}/${dateSplit[0]}`
  }

  return ''
}

export { convertDate, lookupIcon }
